import tracking from "./tracking";

const afterStepChange = state => {
  if (
    !state.isInitialising &&
    (state.previousTemplate == "flow-choice" ||
      state.previousTemplate == "tile-selection" ||
      state.previousTemplate == "button-selection")
  ) {
    const dataLayer = state.data.Steps[state.previousStep].DataLayer;
    let eventLabel =
      state.data.Steps[state.previousStep].Options[state.selectedTileIndex]
        .SalesforcePropertyValue;

    if (!dataLayer) return;

    tracking({
      eventAction: dataLayer.eventaction,
      eventLabel: eventLabel
    });
  }

  let SCROLLTOP_ELEMENT = document.querySelector("#small-mega-menu");
  if (SCROLLTOP_ELEMENT)
    SCROLLTOP_ELEMENT.scrollIntoView({ behavior: "smooth" });

  if (state.activeTemplate === "success") {
    tracking({
      eventAction: "Success"
    });
  }
};

export default afterStepChange;
